import React, { Component } from 'react';
import { Link } from "react-router-dom";
import {
  Table
} from "react-bootstrap";
import $ from 'jquery';
import { apiUrl} from'../Config/Config';
import axios from 'axios';
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import Pagination from "react-js-pagination";
import moment from 'moment';

import { scrollToTopValidate,PageTitle } from "../Helpers/SettingHelper";

/* import { GET_FONTLIST, GET_DELETEFONT } from '../../actions'; */

class List extends Component {
  
  constructor(props)
  {
    super(props); 
    this.state = {
      themelist:'',
      editable: false,
      priorityid:'',
      priorityvalue:'',
      activePage: 1,
      totalRecord: '',
      search_all:'',
      selectid:'',
      actionType: '',
      temTitle: '',
      selectedStatus : '',
      st_theme_id: 0,
      showClonePopup: false,
      cloneTitle: "",
    };

    

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleInputPopupChange = this.handleInputPopupChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

   
   componentDidMount() {
      document.title = PageTitle('Themes');
      if(localStorage.getItem('admin_id') === null){
      this.props.history.push('/');
      }
      this.listloadData()
   }
listloadData(postobject=''){
  var admin_id = localStorage.getItem("admin_id");
  var qs = require('qs');
  if(postobject!=''){
    var postobject=postobject;
  }else{
    var postobject = {
      activePage: 1,
      search_all: '',
      admin_id: admin_id
    };
  }
  
axios.post(apiUrl+"thememanagement/list",qs.stringify(postobject)).then(res => {
 
 if(res.data.status === 'success'){
  this.setState({ totalRecord : res.data.records_count, themelist: res.data.themelist, st_theme_id : res.data.st_theme_id, }, function() {
    this.themelist();
  });
 }
}); 
}
   handlePageChange(pageNumber) {
     // console.log(`active page is ${pageNumber}`);
      this.setState({activePage: pageNumber});
      var qs = require('qs');
      var admin_id = localStorage.getItem("admin_id");
      var postobject = {
        activePage: pageNumber,
        search_all: this.state.search_all,
        admin_id: admin_id
      };
      this.listloadData(postobject)
    }

    handleInputChange(event) {
    const {name, value} = event.target;      
    this.setState({
      [name]: value
    });
    var admin_id = localStorage.getItem("admin_id");
    var postobject = {
      activePage: 1,
      search_all: value,
      admin_id: admin_id
    };
    this.listloadData(postobject)
  }
    handleInputPopupChange(event) {
      const {name, value} = event.target;      
      this.setState({
        [name]: value
      });
    }
  handleFormSubmit = () => {
      
    this.setState({Loading:true});
    var qs = require('qs');
    const formPayload = this.state;
    var admin_id = localStorage.getItem("admin_id");
    var postObject = {             
        activePage : 1,
        search_all : formPayload.search_all,
        admin_id  : admin_id         
    };
    //console.log(postObject);
    this.listloadData(postObject)
      
  }
  // confirmPopup = (id) => {
  //   var status = status;
  //   if(status == 'inactive'){
  //     status = "active";
  //   }else{
  //     status = "inactive";
  //   }
  //   this.setState({selectid: id})	
  //   $('.confirm-action').addClass('show');		
  // }
  // confirmPopup = (id, actionType, title) => {
  //   this.setState({ selectid: id, actionType, temTitle: title });	
  //   $('.confirm-action').addClass('show');		
  // }
  confirmPopup = (id, actionType, title) => {
    if (actionType === "clone") {
      //this.setState({ selectid: id, actionType, cloneTitle: title + " Copy", showClonePopup: true });
      this.setState({ selectid: id, actionType, cloneTitle: "", showClonePopup: true });
    } else {
      this.setState({ selectid: id, actionType, temTitle: title });
      $(".confirm-action").addClass("show");
    }
  };
  
  
  Confirmstatus = (confirmstatus) => {
    if (confirmstatus === 'yes') {
      if (this.state.actionType === 'delete') {
        this.deletetheme();
      } else if (this.state.actionType === 'clone') {
        this.cloneTheme(this.state.selectid);
      }
      else if (this.state.actionType === 'Inactive' || this.state.actionType === 'Active') {
        this.changeStatus(this.state.selectid);
      }
    }
    $('.confirm-action').removeClass('show');
  };


  deletetheme(){
    var qs = require('qs');
    var admin_id = localStorage.getItem("admin_id");
    var postObject = {
      theme_id  :this.state.selectid,
      admin_id  : admin_id
    };
    axios.post(apiUrl+"thememanagement/delete",qs.stringify(postObject)).then(res => {
      if(res.data.status === 'success'){
        $('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');
        setTimeout(
        function() {
        $('.success_message').html('');
        }
        .bind(this),
        3000
        );

        this.listloadData()
      }
    }); 
  }
  cloneTheme = (id) => {
    var admin_id = localStorage.getItem("admin_id");
    var qs = require("qs");
    if (!this.validateThemePopupForm()) {
      return;
    }


    // Step 1: Fetch existing theme details
    axios.post(apiUrl + "thememanagement/view", qs.stringify({ theme_id: id, admin_id })).then((res) => {
        if (res.data.status === "success") {
          let themeData = res.data.themelist;

          // Step 2: Prepare clone object (remove id, add "(Copy)" to title)
          let postObject = {
            admin_id,
            //title: themeData.title + " Copy",
            title: this.state.cloneTitle,
            line_height: themeData.lineHeight,
            pluginRadius: themeData.pluginRadius,
            dropdownRadius: themeData.dropdownRadius,
            inputRadius: themeData.inputRadius,
            textareaRadius: themeData.textareaRadius,
            dashboardGridRadius: themeData.dashboardGridRadius,
            dashboardListRadius: themeData.dashboardListRadius,
            listRowRadius: themeData.listRowRadius,
            st_aisidebar_width: themeData.st_aisidebar_width,
            st_aisidebar_collapsed_width: themeData.st_aisidebar_collapsed_width,
            st_aisidebar_icon_width: themeData.st_aisidebar_icon_width,
            fontDetails: JSON.stringify(themeData.fontDetails),
            shadow: JSON.stringify(themeData.shadow),
            //status: themeData.status,
          };

          // Step 3: Call add API
          axios.post(apiUrl + "thememanagement/add", qs.stringify(postObject)).then((res2) => {
            if (res2.data.status === "success") {
              this.setState({ showClonePopup: false });
              $(".success_message").html(
                '<div class="status_sucess"><h3> The cloning of the theme was successful. </h3></div>'
              );
              setTimeout(() => $(".success_message").html(""), 3000);
              this.listloadData(); // refresh table
            } else {
              this.setState({ showClonePopup: false });
              $(".success_message").html(
                '<div class="status_sucess"><h3>' + res2.data.message + "</h3></div>"
              );
              setTimeout(() => $(".success_message").html(""), 3000);
            }
          });
        }
      });
  };
  validateThemePopupForm() {
    const {cloneTitle} = this.state;

    let errors = 0;
    if (!cloneTitle) {
      errors++;
      $('.errorcloneTitle').html('<span class="errorspan">Please fill the field</span>');
    }else if(cloneTitle){
      $('.errorcloneTitle').html('');
    }
    if(errors>0) {
      setTimeout(function () {
        scrollToTopValidate();
      }, 100);
      return false;
    }
    else {
      return true;
    }
  }

  changeStatus(id = null){
    
    let stat = ''
    if(this.state.actionType ==='Inactive'){
      stat = "I";
    } 
    else if(this.state.actionType ==='Active'){
      stat = "A";
    }  
    var qs = require('qs');
    var postObject = {
      admin_id : localStorage.getItem("admin_id"),
      id  : this.state.selectid,
      status: stat
    };
    axios.post(apiUrl+"thememanagement/changestatus", qs.stringify(postObject)).then(res => {
      if(res.data.status == "success"){
        $('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');
          this.listloadData()
          setTimeout(
          function() {
            $('.success_message').html('');
          }
          .bind(this),
          3000
          );
      }else{
        $('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');
        setTimeout(
          function() {
            $('.success_message').html('');
          }
        .bind(this), 3000);
      }
    });
  }

  themelist() {
    var themelist = this.state.themelist;
    if (themelist != "undefined" && themelist != null) {
        if (Object.keys(themelist).length > 0) {
          const themelistDetails = themelist.map(
            (themelist, Index) => {
              let sno = Index+1;
              if(themelist.status == 'A'){
                var status = 'Active';
              }else{
                var status = 'Inactive';
              }
              return (
                <tr key={themelist.id}>
                <td>{sno}</td>
                  <td>
                  {themelist.title} 
                  {this.state.st_theme_id == themelist.id  ?
                  <i><svg className='ms-2' height="18px" width="18px" xmlns="http://www.w3.org/2000/svg" viewBox="64 64 512 512"><path d="M400 416C497.2 416 576 337.2 576 240C576 142.8 497.2 64 400 64C302.8 64 224 142.8 224 240C224 258.7 226.9 276.8 232.3 293.7L71 455C66.5 459.5 64 465.6 64 472L64 552C64 565.3 74.7 576 88 576L168 576C181.3 576 192 565.3 192 552L192 512L232 512C245.3 512 256 501.3 256 488L256 448L296 448C302.4 448 308.5 445.5 313 441L346.3 407.7C363.2 413.1 381.3 416 400 416zM440 160C462.1 160 480 177.9 480 200C480 222.1 462.1 240 440 240C417.9 240 400 222.1 400 200C400 177.9 417.9 160 440 160z"></path></svg></i>
                  : ''}
                  </td>
                  <td>{themelist.created_on!=null?moment(themelist.created_on).format("MM/DD/YYYY, h:mm A"):'N/A'}</td>   
                  <td>{status}</td>
                  <td className='d-flex gap-2 actiongroup'>
                    {status === 'Active' ? (
                      <Link onClick={() => this.confirmPopup(themelist.id, 'Inactive', themelist.title)} title="Active">
                        <i className="ft-unlock" aria-hidden="true"></i>
                      </Link>
                    ) : (
                      <Link onClick={() => this.confirmPopup(themelist.id, 'Active', themelist.title)} title="In Active">
                        <i className="ft-lock" aria-hidden="true"></i>
                      </Link>
                    )}
                    <Link to={{ pathname: '/theme-edit/'+themelist.id}} className="" title="Edit">  <i className="ft-edit-3" aria-hidden="true"></i></Link>
                    <Link onClick={this.confirmPopup.bind(this,themelist.id, 'delete', themelist.title)} className="" title="Delete">  <i className="ft-trash-2" aria-hidden="true"></i></Link>
                    <Link onClick={() => this.confirmPopup(themelist.id, 'clone', themelist.title)} title="Clone">
                        <i className="ft-copy" aria-hidden="true"></i>
                      </Link>
                  </td>
                </tr>
              );
            }
          );
          return themelistDetails ;
        }  else {
        return (
          <tr>
            <td colspan="6" className="v-align-nr">
              No Result
            </td>
          </tr>
        );
      }
    }
  }
  
  render() {
    return (
      <div className="wrapper"> 
        <div className="confirm-action">
			    <p>Are you sure! you want to {this.state.actionType} the theme?</p>
			    <a href="javascript://" onClick={this.Confirmstatus.bind(this, "yes")} className="btn">Yes</a>
			    <a href="javascript://" onClick={this.Confirmstatus.bind(this, "no")} className="btn">No</a>
		    </div>
         {this.state.showClonePopup && (
          <div className="popup-sec active">
            <div className='popup-sec-in h-auto'>
              <p>Enter a title for cloned theme:</p>
              <input
                type="text"
                value={this.state.cloneTitle}
                name='cloneTitle'
                //onChange={(e) => this.setState({ cloneTitle: e.target.value })}
                onChange={this.handleInputPopupChange}
                className="form-control"
              />
              <div className="errorcloneTitle"></div>
              <div className="d-flex gap-4 justify-content-center mt-4">
                <a href="javascript://"
                  onClick={() => { this.cloneTheme(this.state.selectid); }}
                  className="btn">Clone</a>
                <a href="javascript://"
                  onClick={() => this.setState({ showClonePopup: false })}
                  className="btn">Cancel</a>
              </div>
            </div>
          </div>
        )}
    <Header />
    <MenuSidebar currentpage="themes" />  
      
      <div className="content"> 
        <div className="content-wrapper">
              <div class="content-wrapper-before"></div>
            <div className="car-listing-wrap leaa-admin-head card">
            <div className="success_message"></div>
              <div className="listing-header">
                <div className="title">
                  <h3>{this.state.totalRecord} Theme{this.state.totalRecord>1 ? 's' : ''}</h3>
                </div>

                 <div className="search-list">
                   <form className="edit" id="edit" onSubmit={ e => { this.handleFormSubmit(this); e.preventDefault(); }} >     
                    <div className="search-inner">
                      <input type="text" name="search_all" onChange={this.handleInputChange} className="form-control" value={this.state.search_all} placeholder="Search" /> 
                     <button className="" type="submit">Submit</button>
                    <div className="erroremail"></div>
                  </div>
                 </form>
                </div>
                {/* <div className="add_button">  
                    <a className="btn" href='/theme-add'>Add</a> 
                </div> */}
              </div>            
              {/*<div className="statusmessage"></div>*/}

              <div className="car-listing-row">
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>S.NO</th>
                      <th>Template Name</th>
                      <th>Added On</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>{this.themelist()}</tbody>
                </Table>
                 <div className="text-center">
            <Pagination
            activePage={this.state.activePage}
            itemsCountPerPage={10}
            totalItemsCount={this.state.totalRecord}
            pageRangeDisplayed={5}
            onChange={this.handlePageChange.bind(this)}
            />
          </div>
              </div>

            </div> 
        </div>  
      </div>
      
    </div>
    );
  }
}


export default List;